import { PathologyCreateOrderFormRequestSchema } from '@quromedical/models';
import { z } from 'zod';

export type PathologyCreateOrderForm = z.infer<typeof PathologyCreateOrderFormRequestSchema>;
